/**
 * Whether the account menu should offer 教育城EdConnect (and the dialog
 * behind it).
 *
 * The item is how a username/email teacher LINKS EdCity. An account CREATED
 * through EdCity already IS its EdCity identity: it has nothing to bind, and
 * the dialog's unbind button would drop its only sign-in method — the composer
 * cmd behind that button (`unbind_edconnect`) has NO last-credential guard, so
 * this test is the whole protection.
 *
 * `has_password` is the server's marker for such an account: SSO provisioning
 * INSERTs an empty `password_hash` (identity_service), and every human-created
 * path sets a credential — the same invariant the API itself uses to tell a
 * provisioned account apart (`edconnect._conflict_is_created_account`).
 *
 * FAIL CLOSED: only a positive `has_password === true` shows the item. It used
 * to be the other way round — anything but `false` showed it — so that a
 * composer build could not hide the item for everyone before the API shipped
 * the flag. The API has shipped it on every route the composer logs in
 * through, and fail-open turned out to cost more than it saved: a session
 * restored from localStorage replays a `user_info` frozen at the last real
 * sign-in (RootPage.checkExistingSession), and the EdCity return leg paints
 * TopBar before the code exchange has produced any `user_info` at all. In both
 * windows the flag is `undefined` — and under the old test an EdCity-native
 * teacher was shown the one control that can lock them out of their account.
 * The two mistakes are not symmetrical: wrongly hiding costs a password
 * teacher a binding they can still ask support for, wrongly showing costs an
 * EdCity teacher the account.
 */
export function showEdConnectMenuItem({
  bindingEnabled = false,
  googleBindingEnabled = false,
  appleLoginEnabled = false,
  hasPassword,
} = {}) {
  if (hasPassword !== true) {
    return false;
  }
  return Boolean(bindingEnabled || googleBindingEnabled || appleLoginEnabled);
}
